export default "__VITE_ASSET__BxIZDeZ6__"